import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4a0db51c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4a0db51c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0db51c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0db51c')) {
      api.createRecord('4a0db51c', component.options)
    } else {
      api.reload('4a0db51c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4a0db51c&scoped=true", function () {
      api.rerender('4a0db51c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/csg/StorageTransactionReport/index.vue"
export default component.exports